import {
	json,
	type LoaderFunctionArgs,
	type MetaFunction,
} from '@remix-run/node'
import { useSearchParams } from '@remix-run/react'
import { GeneralErrorBoundary } from '#app/components/error-boundary.tsx'
import { requireAnonymous } from '#app/utils/auth.server.ts'
import {
	ProviderConnectionForm,
	providerNames,
} from '#app/utils/connections.tsx'

export async function loader({ request }: LoaderFunctionArgs) {
	await requireAnonymous(request)
	return json({})
}

export default function LoginPage() {
	const [searchParams] = useSearchParams()
	const redirectTo = searchParams.get('redirectTo')

	return (
		<div className="flex min-h-full flex-col justify-center pb-32 pt-20">
			<div className="mx-auto w-full max-w-md">
				<div className="mx-auto w-full max-w-md px-8">
					<h1 className="mb-5 text-center text-3xl font-bold">
						Potřebná autorizace
					</h1>
					<ul className="mt-5 flex flex-col gap-5 py-3">
						{providerNames.map(providerName => (
							<li key={providerName}>
								<ProviderConnectionForm
									providerName={providerName}
									redirectTo={redirectTo}
								/>
							</li>
						))}
					</ul>
				</div>
			</div>
		</div>
	)
}

export const meta: MetaFunction = () => {
	return [{ title: 'Authorization needed' }]
}

export function ErrorBoundary() {
	return <GeneralErrorBoundary />
}
